
    import '/opt/buildhome/repo/docs/playground/agent-tbox.zh-CN.md?watch=parent';
    export const toc = [{"id":"docs-playground-agent-tbox-demo-agent-tbox","depth":3,"title":"百宝箱 X 智能体"}];
export const frontmatter = {"title":"百宝箱","toc":"menu","filename":"docs/playground/agent-tbox.zh-CN.md","lastUpdated":1759172124000,"group":{"title":"智能体样板间","order":1},"description":"百宝箱 X 智能体","order":0};